import React from "react";
import {
  Directions,
  competitionConstants,
  eventConstants,
  timezoneConstants,
  translationConstants,
  viewPathConstants,
} from "../../../../../constants";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import SPOT_IMG from "../../../../../assets/images/icon/maps-and-flags.png";
import activityTimeIcon from "../../../../../assets/images/icon/calender_time_icon.svg";
import {
  dateToUTCWithTimezone,
  DaysLeft,
  dashboardEventDaysLeft,
  serverFormatToDateString,
} from "../../../../../system";

const UpcomingEventsCard = ({ eventData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );
  const cities = useSelector((state) => state.LoginReducer.cities);
  const daysLeft = dashboardEventDaysLeft(eventData?.startDateString);
  const isToday = daysLeft == 0;

  return (
    <>
      <div
        className="bg-light p-2 rounded my-2 centers-detail-card cast-shadow-on-hover"
        onClick={() => {
          if (eventData.isEvent) {
            navigate(
              `${viewPathConstants.VIEW_EVENT_DETAIL}?${eventConstants.EVENT_ID}=${eventData?.id}`,
              {
                state: {
                  eventId: eventData?.id,
                  isActive: eventData?.isActive,
                },
              }
            );
          } else {
            navigate(`${viewPathConstants.PUBLIC_COMPETITIONS_DETAIL}`, {
              state: {
                flag: competitionConstants.UPCOMING,
                competitionId: eventData?.id,
              },
            });
          }
        }}
      >
        <div className="row d-flex gap-2">
          <div className="col-md-5 col-4 gap-3 upcomming-card-image-wrapper position-relative">
            <img
              className="img-fluid rounded side-view-image"
              src={
                eventData?.logo?.link
                  ? eventData?.logo?.link
                  : "https://images-platform.99static.com//yiqGDg-23aQs9hZXp_bf5F3KR38=/374x187:877x691/fit-in/500x500/99designs-contests-attachments/97/97674/attachment_97674594"
              }
              alt=""
            />
            <span className="img-overlap"></span>
            <div className={`days-left ${isToday && "days-left-today"}`}>
              {isToday ? (
                <div>{t(translationConstants.STARTING_TODAY)}</div>
              ) : (
                <h2>{daysLeft}</h2>
              )}
              <span>{!isToday && t(translationConstants.DAYSLEFT)}</span>
            </div>
          </div>
          <div className="col-lg-6 col-12 d-flex gap-md-0 flex-column justify-content-between align-items-start">
            <div className="py-2">
              <h6 className="sidebar-card-heading">
                {" "}
                {direction === Directions.rtl
                  ? eventData?.arabicTitle
                    ? eventData?.arabicTitle
                    : eventData?.title
                  : eventData?.title}{" "}
              </h6>
              <div className="d-flex flex-column gap-2">
                <div className="d-flex gap-2 align-items-center">
                  <img alt="" name="sidebarCards" src={activityTimeIcon} />
                  <h6 className="sidebar-card-date">
                    {`${serverFormatToDateString(
                      eventData?.startDateString,
                      timezoneConstants.hourMinuteFormat
                    )}`}
                  </h6>
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="16"
                    viewBox="0 0 15 16"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.20648 4.45209H4.02071V3.85921H2.83541V5.63786H12.3215V3.85921H11.1358V4.45209H9.94999V3.85921H5.20648V4.45209ZM12.3215 6.82362H2.83541V12.7524H12.3215V6.82362ZM9.94999 2.67345H5.20648V2.08057H4.02071V2.67345H2.83518C2.1803 2.67345 1.64941 3.20433 1.64941 3.85921V12.7524C1.64941 13.4073 2.1803 13.9382 2.83518 13.9382H12.3213C12.9762 13.9382 13.5071 13.4073 13.5071 12.7524V3.85921C13.5071 3.20433 12.9762 2.67345 12.3213 2.67345H11.1358V2.08057H9.94999V2.67345ZM5.79982 9.19526H4.61406V8.0095H5.79982V9.19526ZM6.98535 9.19515H8.17112V8.00938H6.98535V9.19515ZM10.5424 9.19526H9.35665V8.0095H10.5424V9.19526ZM4.61406 11.5666H5.79982V10.3808H4.61406V11.5666ZM8.17112 11.5667H6.98535V10.3809H8.17112V11.5667Z"
                      fill="black"
                    />
                  </svg>
                  <h6 className="sidebar-card-date">
                    {`${serverFormatToDateString(
                      eventData?.startDateString,
                      timezoneConstants.dayMonthYearFormat
                    )}`}
                  </h6>
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <img src={SPOT_IMG} alt="spotIcon" className="" />
                  <h6 className="sidebar-card-date">
                    {`${
                      direction === Directions.rtl && eventData?.spotArabicName
                        ? eventData?.spotArabicName
                        : eventData?.spotName
                        ? eventData?.spotName + ", "
                        : ""
                    } ${
                      cities?.find(
                        (city) =>
                          city.id === eventData?.eventCityId ||
                          city.id === eventData?.spotCityId
                      )?.[direction === Directions.rtl ? "arabicName" : "name"]
                    }`}
                  </h6>
                </div>
                <span
                  className="center-card-view-detail-link approved-color"
                  onClick={() => {
                    if (eventData.isEvent) {
                      navigate(
                        `${viewPathConstants.VIEW_EVENT_DETAIL}?${eventConstants.EVENT_ID}=${eventData?.id}`
                      );
                    } else {
                      navigate(
                        `${viewPathConstants.PUBLIC_COMPETITIONS_DETAIL}`,
                        {
                          state: {
                            flag: competitionConstants.UPCOMING,
                            competitionId: eventData?.id,
                          },
                        }
                      );
                    }
                  }}
                >
                  {t(translationConstants.VIEW_DETAILS)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpcomingEventsCard;
